import './lib/process-shim';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChatWidget, mountWidgetFromCurrentScript } from './components/chat-widget';
import './styles.css';

function ensureWidgetStylesheet() {
  const currentScript =
    document.currentScript instanceof HTMLScriptElement ? document.currentScript : null;

  if (!currentScript?.src) {
    return;
  }

  const stylesheetUrl = currentScript.src.replace(/widget\.iife\.js(?:\?.*)?$/, 'widget.css');
  if (!stylesheetUrl || stylesheetUrl === currentScript.src) {
    return;
  }

  const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(
    (link) => link instanceof HTMLLinkElement && link.href === stylesheetUrl,
  );

  if (existing) {
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = stylesheetUrl;
  document.head.appendChild(link);
}

function bootstrap() {
  ensureWidgetStylesheet();
  const { widgetKey, apiBaseUrl, mountTarget } = mountWidgetFromCurrentScript();
  const root = ReactDOM.createRoot(mountTarget);
  root.render(
    <React.StrictMode>
      <ChatWidget widgetKey={widgetKey} apiBaseUrl={apiBaseUrl} />
    </React.StrictMode>,
  );
}

bootstrap();
